import React, { useState, useEffect, useContext } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
  UncontrolledTooltip,
} from "reactstrap";
import AdminHeader from "components/Headers/AdminHeader";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { urlDecodedId } from "components/CommonComponents/encodeDecodeFunction";
import TraineeCourses from "./TraineeCourses";
import TraineeCertificates from "./TraineeCertificates";
import TraineeDocuments from "./TraineeDocuments";
import { getTraineeDetailByID } from "action/trainee";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";
import { toCamelCase } from "components/CommonComponents/CommonFunctions";
import { downloadTraineeQRCode } from "action/trainee";
import TraineeLetterListing from "./TraineeLetterListing";
import {
  TRAINEE_CATEGORY_OPTIONS,
  TRAINEE_TYPE_OPTIONS,
} from "components/constant";
import DetailsHeader from "components/CommonComponents/DetailsHeader";
import TraineeAssessment from "./TraineeAssessment";

const initialFields = {
  jointerID: "",
  fullName: "",
  email: "",
  mobile: "",
  gender: "",
  status: "",
  dob: "",
  createdOn: "",
  organization: "",
  enrollmentType: "",
  skills: [],
  qrCodePath: "",
  qrFileName: "",
  governmentID: "",
  state: "",
  city: "",
  pincode: "",
  addressLine1: "",
  addressLine2: "",
  landmark: "",
  traineeCategory: "",
  traineeType: "",
  channelPartner: "",
  documents: [],
};

export const downloadImage = (imageUrl, fileName = "image.jpg") => {
  const link = document.createElement("a");
  link.href = imageUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

function TraineeDetails() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const { id } = useParams();
  const decodedId = id ? urlDecodedId(id) : null;
  const { notify } = useContext(NotificationContext);
  const [data, setData] = useState(initialFields);
  const [showAlternative, setShowAlternative] = useState({
    isLoading: true,
    error: "",
  });
  const [isDownloading, setIsDownloading] = React.useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const [showImageModal, setShowImageModal] = useState(false);
  const [activeTab, setActiveTab] = useState("details");

  // const channelPartners =
  //   useSelector(
  //     (state) => state.channelPartner.channelPartnerList?.data?.channelPartners,
  //   ) || [];

  // useEffect(() => {
  //   if (location?.state?.channel) {
  //     setData((prev) => ({
  //       ...prev,
  //       enrollmentType: "Institute",
  //       organization: "ABC Institute",
  //     }));
  //   }
  // }, [location?.state?.channel]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setActiveTab(params.get("tab") || "details");
  }, [location.search]);

  // useEffect(() => {
  //   getChannelPartnerList(dispatch);
  // }, [dispatch]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      const params = new URLSearchParams(location.search);
      params.set("tab", tab);
      navigate(`${location.pathname}?${params.toString()}`, {
        replace: true,
      });
    }
  };

  useEffect(() => {
    if (!decodedId) return;
    const fetchDetails = async () => {
      try {
        setShowAlternative((prev) => ({ ...prev, isLoading: true }));
        const res = await getTraineeDetailByID(decodedId);

        if (res?.code === 200 && res?.data) {
          const trainee = res.data;

          setData({
            ID: trainee?.ID,
            userID: trainee?.userID,
            jointerID: trainee?.uUID || "-",
            fullName: `${trainee?.firstName || ""} ${trainee?.lastName || ""}`,
            email: trainee?.email || "-",
            mobile: trainee?.mobile || "-",
            gender: trainee?.gender ? toCamelCase(trainee.gender) : "-",
            status: trainee?.status || "-",
            dob: trainee?.dob || "-",
            createdOn: trainee?.createdAt || "-",
            organization: trainee?.organizationName || "",
            enrollmentType: trainee?.enrollmentType || "-",
            skills: trainee?.skills || [],
            qrCodePath: trainee?.qrCodePath || "",
            qrFileName: trainee?.qrFileName || "qr-code.png",
            profileImage: trainee?.profileImagePath || "",
            governmentID: trainee?.governmentID || "",
            state: trainee?.city?.state?.name || "-",
            city: trainee?.city?.name || "-",
            pincode: trainee?.pincode || "-",
            addressLine1: trainee?.lineOne || "-",
            addressLine2: trainee?.lineTwo || "-",
            landmark: trainee?.landmark || "-",
            traineeCategory: trainee?.traineeCategory || "-",
            traineeType: trainee?.traineeType || "-",
            channelPartner: trainee?.channelPartnerName || "-",
            // channelPartners.find(
            //   (item) => item.ID === trainee?.channelPartnerID,
            // )?.organizationName || "-",
            documents: trainee?.documents || [],
          });
          setShowAlternative((prev) => ({
            ...prev,
            isLoading: false,
            error: "",
          }));
        } else {
          setShowAlternative((prev) => ({
            ...prev,
            isLoading: false,
            error: res?.message || "Failed to load trainee details",
          }));
        }
      } catch (error) {
        setShowAlternative((prev) => ({
          ...prev,
          isLoading: false,
          error: error?.message || "Failed to load trainee details",
        }));
      }
    };
    // if (activeTab === "details") {
    fetchDetails();
    // }
  }, [decodedId]);

  const renderData = (label, value) => {
    return (
      <div className="mb-1 d-flex flex-column align-items-start ">
        <Label className="small-label text-muted mb-1">{label}</Label>
        <p className="small-text text-wrapper">{value || "-"}</p>
      </div>
    );
  };

  const downloadQR = async (trainee) => {
    setIsDownloading(true);
    try {
      const res = await downloadTraineeQRCode(trainee);
      if (res.status === 200 && res.data) {
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1] ||
          "qr-code.png";

        const url = URL.createObjectURL(res.data);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else if (res.code === 404) {
        notify(
          "danger",
          "The QR code for this trainee was not found. Please regenerate it.",
        );
      } else {
        notify("danger", "Failed to download QR code. Please try again.");
      }
    } catch (error) {
      notify("danger", "Failed to download QR code. Please try again.");
    }
    setIsDownloading(false);
  };

  const handleBack = () => {
    if (location?.state?.from === "documents-approval") {
      navigate(
        role === "CHANNEL_PARTNER"
          ? "/channel-partner/document-approval"
          : "/admin/document-approval",
      );
      return;
    }
    navigate(
      location?.state?.channel
        ? role === "SUPER_ADMIN"
          ? `/super-admin/channel-partner/${location?.state?.channel}/details`
          : role === "CHANNEL_PARTNER"
            ? `/channel-partner/channel-partner/${location?.state?.channel}/details`
            : `/admin/channel-partner/${location?.state?.channel}/details`
        : role === "SUPER_ADMIN"
          ? "/super-admin/trainee/"
          : role === "CHANNEL_PARTNER"
            ? "/channel-partner/trainee/"
            : "/admin/trainee/",
    );
  };

  const handleEdit = () => {
    navigate(
      role === "SUPER_ADMIN"
        ? `/super-admin/trainee/edit/${id}`
        : role === "CHANNEL_PARTNER"
          ? `/channel-partner/trainee/edit/${id}`
          : `/admin/trainee/edit/${id}`,
      { state: { mode: "edit" } },
    );
  };

  return (
    <>
      <AdminHeader />
      {isDownloading && (
        <div className="logout-overlay">
          <div className="logout-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-3" />
            <div className="font-weight-bold text-dark">
              Downloading… Please wait.
            </div>
          </div>
        </div>
      )}
      {isDownloading && (
        <div className="logout-overlay">
          <div className="logout-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-3" />
            <div className="font-weight-bold text-dark">
              Downloading… Please wait.
            </div>
          </div>
        </div>
      )}
      <Container fluid className="mt--6 course-layout">
        <Row>
          <Col md="12">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="d-flex align-items-center text-white ml-1">
                <span className="font-weight-bold small-text">
                  Trainee Details
                </span>
              </div>
              {/* <Button
                onClick={() =>
                  navigate(
                    role === "SUPER_ADMIN"
                      ? `/super-admin/trainee/edit/${id}`
                      : role === "CHANNEL_PARTNER"
                        ? `/channel-partner/trainee/edit/${id}`
                        : `/admin/trainee/edit/${id}`,
                    {
                      state: { mode: "edit" },
                    },
                  )
                }
              >
                <i className="fa fa-pencil mr-1" />
                Edit
              </Button> */}
            </div>

            <DetailsHeader
              isLoading={showAlternative.isLoading}
              onBack={handleBack}
              backTooltip="Back to Trainees"
              showProfile={true}
              profileImage={data?.profileImage}
              onProfileClick={() => setShowImageModal(true)}
              title={data?.fullName}
              status={data?.status}
              showEdit={activeTab === "details"}
              onEdit={handleEdit}
              editLabel="Edit"
              editTooltip="Edit Trainee"
              editIcon="fa fa-pencil"
              chips={[
                {
                  id: "tdEmailChip",
                  icon: "fas fa-envelope",
                  value: data?.email,
                  tooltip: data?.email,
                },
                {
                  id: "tdPhoneChip",
                  icon: "fas fa-phone",
                  value: data?.mobile,
                  tooltip: data?.mobile,
                },
                {
                  id: "tdJidChip",
                  icon: "fas fa-id-badge",
                  name: "Jointer ID",
                  value: data?.jointerID,
                  tooltip: `Jointer ID: ${data?.jointerID}`,
                },
              ]}
            />

            <Card className="mt-3">
              <CardHeader className="pb-0 course-sticky-header">
                <Nav className="custom-tabs cursor">
                  <NavItem>
                    <NavLink
                      className={activeTab === "details" ? "active" : ""}
                      onClick={() => toggleTab("details")}
                    >
                      Overview
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      className={activeTab === "documents" ? "active" : ""}
                      onClick={() => toggleTab("documents")}
                    >
                      Documents
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      className={activeTab === "courses" ? "active" : ""}
                      onClick={() => toggleTab("courses")}
                    >
                      Courses
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "assessments" ? "active" : ""}
                      onClick={() => toggleTab("assessments")}
                    >
                      Assessments
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "letters" ? "active" : ""}
                      onClick={() => toggleTab("letters")}
                    >
                      Letters
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "certificates" ? "active" : ""}
                      onClick={() => toggleTab("certificates")}
                    >
                      Certificates
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>
              <CardBody>
                <TabContent activeTab={activeTab}>
                  <TabPane className="course-details" tabId="details">
                    {showAlternative.isLoading ? (
                      <div className="loaderContainer-sm">
                        <i className="fa fa-spinner fa-spin fa-2xl isLoading" />
                      </div>
                    ) : showAlternative.error ? (
                      <>
                        <div className="loaderContainer-sm error-style">
                          <div className="error-icon">
                            <i class="fa-solid fa-circle-exclamation"></i>
                          </div>
                          <span>{showAlternative.error}</span>
                        </div>
                      </>
                    ) : (
                      <>
                        <Row className="align-items-stretch">
                          <Col md="8" className="d-flex">
                            <Card className="section-cards w-100">
                              <CardHeader className="section-header">
                                <h4 className="mb-0 text-default section-title">
                                  Basic Information
                                </h4>
                              </CardHeader>
                              <CardBody>
                                <Row>
                                  <Col md="6" lg="4">
                                    {renderData("Jointer ID", data.jointerID)}
                                  </Col>
                                  <Col md="6" lg={"4"}>
                                    {renderData("Name", data.fullName)}
                                  </Col>
                                  <Col md="6" lg="4">
                                    {renderData("Email", data.email)}
                                  </Col>
                                  <Col md="6" lg="4">
                                    {renderData("Mobile Number", data.mobile)}
                                  </Col>
                                  <Col md="6" lg="4">
                                    {renderData("Date of Birth", data.dob)}
                                  </Col>
                                  <Col md="6" lg="4">
                                    {renderData("Gender", data.gender)}
                                  </Col>
                                  <Col md="6" lg="4">
                                    {renderData(
                                      "Government ID",
                                      data.governmentID || "-",
                                    )}
                                  </Col>
                                  <Col md="6" lg="4">
                                    {renderData(
                                      "Enrollment Type",
                                      data.enrollmentType,
                                    )}
                                  </Col>

                                  <Col md="6" lg="4">
                                    {renderData(
                                      "Registered On",
                                      data.createdOn,
                                    )}
                                  </Col>
                                  {/* <Col md="6" lg="4">
                                <div className="mb-3 d-flex flex-column align-items-start ">
                                  <Label className="small-label text-muted mb-1">
                                    Status
                                  </Label>
                                  <Badge
                                    pill
                                    color={
                                      data.status === "ACTIVE"
                                        ? "success"
                                        : "warning"
                                    }
                                    className="badge-lg"
                                  >
                                    {data.status}
                                  </Badge>
                                </div>
                              </Col> */}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>

                          <Col md="4" className="d-flex">
                            <Card className="section-cards w-100">
                              <CardHeader className="section-header">
                                <h4 className="mb-0 text-default section-title">
                                  QR Code
                                  <i
                                    className="fa fa-info-circle ml-1 text-muted"
                                    id={`qrcode${data.jointerID}`}
                                  />
                                </h4>

                                <UncontrolledTooltip
                                  delay={0}
                                  target={`qrcode${data.jointerID}`}
                                  innerClassName="custom-tooltip"
                                >
                                  Scan this QR code on the Skills Verification
                                  Portal to verify the trainee's identity and
                                  authenticate their training letters.
                                </UncontrolledTooltip>
                              </CardHeader>

                              <CardBody className="qr-card-body">
                                <Row className="align-items-center">
                                  <Col md="12">
                                    <div className="svp-profile-qr">
                                      <img
                                        src={data?.qrCodePath}
                                        alt="No QR Code available"
                                      />
                                      {/* <span className="mt-3">Scan to verify</span>
                                  <span className="cursor" onClick={() => downloadQR(data?.ID)}>Click to download</span> */}

                                      <div className="qr-actions">
                                        <span className="qr-title">
                                          Scan to verify
                                        </span>

                                        <button
                                          type="button"
                                          className="qr-download-btn"
                                          onClick={() => downloadQR(data?.ID)}
                                        >
                                          <i className="fas fa-download me-2"></i>
                                          Download QR Code
                                        </button>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        <Row>
                          <Col md="6" className="d-flex">
                            <Card className="section-cards w-100">
                              <CardHeader>
                                <h4 className="mb-0 text-default section-title">
                                  Address Details
                                </h4>
                              </CardHeader>

                              <CardBody>
                                <Row>
                                  <Col md="6">
                                    {renderData(
                                      "Address Line 1",
                                      data.addressLine1,
                                    )}
                                  </Col>

                                  <Col md="6">
                                    {renderData(
                                      "Address Line 2",
                                      data.addressLine2,
                                    )}
                                  </Col>

                                  <Col md="6">
                                    {renderData("Landmark", data.landmark)}
                                  </Col>

                                  <Col md="6">
                                    {renderData("State", data.state)}
                                  </Col>

                                  <Col md="6">
                                    {renderData("City", data.city)}
                                  </Col>

                                  <Col md="6">
                                    {renderData("Pincode", data.pincode)}
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>

                          <Col md="6" className="d-flex">
                            <Card className="section-cards w-100">
                              <CardHeader>
                                <h4 className="mb-0 text-default section-title">
                                  Trainee Classification
                                </h4>
                              </CardHeader>

                              <CardBody>
                                <Row>
                                  <Col md="6" lg="6">
                                    {renderData(
                                      "Trainee Category",
                                      TRAINEE_CATEGORY_OPTIONS.find(
                                        (opt) =>
                                          opt.value === data?.traineeCategory,
                                      )?.label || "-",
                                    )}
                                  </Col>

                                  {data.traineeCategory !== "RRL" && (
                                    <Col md="6" lg="6">
                                      {renderData(
                                        "Trainee Type",
                                        TRAINEE_TYPE_OPTIONS.find(
                                          (opt) =>
                                            opt.value === data?.traineeType,
                                        )?.label || "-",
                                      )}
                                    </Col>
                                  )}

                                  {data.traineeCategory ===
                                    "THIRD_PARTY_CONTRACTOR" && (
                                    <Col md="6" lg="6">
                                      {renderData(
                                        data.traineeCategory ===
                                          "THIRD_PARTY_CONTRACTOR"
                                          ? "Channel Partner & Organization Name"
                                          : "Channel Partner",
                                        data.channelPartner || "-",
                                      )}
                                    </Col>
                                  )}

                                  {/* {data.enrollmentType === "Institute" && ( */}
                                  {data.traineeCategory === "ORGANIZATION" && (
                                    <Col md="6" lg="6">
                                      {renderData(
                                        "Organization Name",
                                        data.organization || "-",
                                      )}
                                    </Col>
                                  )}

                                  {/* )} */}

                                  {/* <Col md="12">
                                <div className="mb-3 d-flex flex-column align-items-start w-100">
                                  <Label className="small-label text-muted mb-2">
                                    Prerequisites Documents
                                  </Label>

                                  {data?.documents?.length > 0 ? (
                                    <div className="d-flex flex-wrap">
                                      {data.documents.map((doc, index) => {
                                        const isPdf = doc?.documentPath
                                          ?.toLowerCase()
                                          ?.includes(".pdf");

                                        return (
                                          <div
                                            key={index}
                                            className="position-relative mr-3 mb-3"
                                          >
                                            <a
                                              href={doc.documentPath}
                                              target="_blank"
                                              rel="noreferrer"
                                              className="text-decoration-none"
                                            >
                                              <div className="doc-preview-container">
                                                <div className="doc-preview">
                                                  {isPdf ? (
                                                    <div className="pdf-preview">
                                                      <i className="fa fa-file-pdf text-danger fa-4x"></i>
                                                    </div>
                                                  ) : (
                                                    <img
                                                      src={doc.documentPath}
                                                      className="doc-image"
                                                      alt="Document"
                                                    />
                                                  )}
                                                </div>

                                                <div className="doc-actions">
                                                  <Button
                                                    color="link"
                                                    size="sm"
                                                    className="doc-action-btn"
                                                    title="View"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      window.open(
                                                        doc.documentPath,
                                                        "_blank",
                                                      );
                                                    }}
                                                  >
                                                    <i className="fa fa-eye mr-5" />
                                                  </Button>
                                                </div>
                                              </div>
                                            </a>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  ) : (
                                    <div className="small-text">-</div>
                                  )}
                                </div>
                              </Col> */}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>

                        {/* <Row>
                      <Col md="7">
                        <Card>
                          <CardHeader>
                            <h4 className="mb-0">Skills (Static Data)</h4>
                          </CardHeader>

                          <CardBody className="cardStyle">
                            <Row className="align-items-center mb-3">
                              <Col md="12">
                                {data?.skills && data?.skills.length > 0 ? (
                                  <div className="skills-div">
                                    {data.skills.map((skill, i) => (
                                      <span key={i} className="skill-pill">
                                        {skill}
                                      </span>
                                    ))}
                                  </div>
                                ) : (
                                  <div className="d-flex justify-content-center align-items-center py-3">
                                    <span className="text-muted mt-4">
                                      No skills found
                                    </span>
                                  </div>
                                )}
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col md="5">
                        <Card>
                          <CardHeader>
                            <h4 className="mb-0">Learning Summary (Static Data)</h4>
                          </CardHeader>

                          <CardBody className="cardStyle">
                            <Row className="align-items-center mb-3">
                              <Col md="12">
                                <div className="svp-profile-stats">
                                  <div
                                    className="stat-item enrolled cursor"
                                    onClick={() => toggleTab("courses")}
                                  >
                                    <h2>9</h2>
                                    <span>
                                      <i className="fas fa-book-open mr-1" />
                                      Enrolled Courses
                                    </span>
                                  </div>

                                  <div
                                    className="stat-item pending cursor"
                                    onClick={() => toggleTab("courses")}
                                  >
                                    <h2>3</h2>
                                    <span>
                                      <i className="fas fa-hourglass-half mr-1" />
                                      In_Progress Courses
                                    </span>
                                  </div>

                                  <div
                                    className="stat-item completed cursor"
                                    onClick={() => toggleTab("courses")}
                                  >
                                    <h2>6</h2>
                                    <span>
                                      <i className="fas fa-check-circle mr-1" />
                                      Completed Courses
                                    </span>
                                  </div>

                                  <div
                                    className="stat-item certificate cursor"
                                    onClick={() => toggleTab("certificates")}
                                  >
                                    <h2>6</h2>
                                    <span>
                                      <i className="fas fa-certificate mr-1" />
                                      Earned Certificates
                                    </span>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row> */}
                      </>
                    )}
                  </TabPane>

                  <TabPane tabId="documents">
                    {activeTab === "documents" && <TraineeDocuments />}
                  </TabPane>

                  <TabPane tabId="courses">
                    {activeTab === "courses" && (
                      <TraineeCourses traineeID={data?.ID} />
                    )}
                  </TabPane>

                  <TabPane tabId="certificates">
                    <TraineeCertificates />
                  </TabPane>

                  <TabPane tabId="letters">
                    {activeTab === "letters" && (
                      <TraineeLetterListing userID={data.userID} />
                    )}
                  </TabPane>
                  <TabPane tabId="assessments">
                    {activeTab === "assessments" && <TraineeAssessment />}
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {showImageModal && (
        <div
          className="image-modal-overlay"
          onClick={() => setShowImageModal(false)}
        >
          <div className="image-modal-content">
            <img src={data.profileImage} alt="profile-large" />
          </div>
        </div>
      )}
    </>
  );
}

export default TraineeDetails;
